import React from 'react'
import axios from 'axios'
import moment from 'moment'
import { LoaderCircle } from 'lucide-react'

class TutorMeetings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      meetings: [],
      loading: true
    }
  }

  componentDidMount() {
    axios.get(`/api/sales/tutoring_jobs/${this.props.tutoring_job_id}/meetings`, {
      params: { tutor_id: this.props.tutor_id }
    })
      .then((response) => {
        this.setState({ meetings: response.data.meetings, loading: false })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  stateLabel(state) {
    switch (state) {
      case 'scheduled': return { text: 'Scheduled', style: 'bg-emerald-100 text-emerald-800' }
      case 'alternative_suggested': return { text: 'Alt. Suggested', style: 'bg-amber-100 text-amber-800' }
      case 'cancelled': return { text: 'Cancelled', style: 'bg-muted text-muted-foreground' }
      default: return { text: state, style: 'bg-muted text-muted-foreground' }
    }
  }

  render() {
    const { meetings, loading } = this.state

    if (loading) {
      return <div className="py-4 text-center text-muted-foreground"><LoaderCircle className="mx-auto size-4 animate-spin"/></div>
    }

    if (meetings.length === 0) {
      return <div className="py-4 text-[13px] text-muted-foreground">No meetings for this tutor</div>
    }

    return (
      <div className="divide-y divide-border">
        {meetings.map((meeting) => {
          const status = this.stateLabel(meeting.workflow_state)
          const participants = meeting.participants || []

          return (
            <div key={meeting.id} className="flex items-center justify-between py-2">
              <div>
                <div className="text-[13px] font-semibold">
                  {moment(meeting.start_time).format('ddd D MMM')}
                  <span className="ml-2 font-normal text-muted-foreground">
                    {moment(meeting.start_time).format('h:mm A')} - {moment(meeting.end_time).format('h:mm A')}
                  </span>
                </div>
                <div className="text-xs text-muted-foreground">
                  {participants.map(p => p.name).join(', ')}
                </div>
              </div>
              <span className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-medium ${status.style}`}>
                {status.text}
              </span>
            </div>
          )
        })}
      </div>
    )
  }
}

export default TutorMeetings
